import React, { Component } from "react";
import { HTAttachment, HTDocLookup } from "../../api/entities";
import { ErrorContainer } from "@eres/forms";
import Context from "../../Context";
import Strings from "@my-dld/assets/strings";
import FormRow from "@eres/forms-web/FormRow";
import { RenderDocumentCategory } from "./Damages";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { mapLookupWithAttachments, onDocDrop, setRequest } from "../../Utils";
import { EjariApi } from "@eres/ejari-api";
import { loadDocsLookUp } from "../../api/api";
import { HTDocType, HTLookUps } from "../../api/constants";
import { RenderDocs } from "./RejectionInfo";

interface Props {
	mode: "edit" | "view";
}

interface State {
	isLoading?: boolean;
	documents: HTDocLookup[];
	errorContainer: ErrorContainer;
}

class HandoverDocs extends Component<Props, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			documents: [],
			errorContainer: {},
		};
	}

	componentDidMount() {
		this.loadDocuments();
	}

	render() {
		if ( this.props.mode === "view" ) {
			return <RenderInfo state={ this.state }/>;
		}
		const { isLoading, documents, errorContainer } = this.state;
		return <div className="card mb-3">
			<div className="card-header">
				<span>{ Strings.documents }</span>
			</div>
			<div className="card-body">
				{ isLoading && <span className="spinner-border"/> }
				<FormRow>
					<RenderDocumentCategory
						documents={ documents }
						onRejected={ this.onRejected }
						onDrop={ this.onDrop }
						onDelete={ this.onDelete }
						errorContainer={ errorContainer }/>
				</FormRow>
			</div>
		</div>;
	}

	public getDocuments(): Promise<HTDocLookup[]> {
		const error: ErrorContainer = {};
		const { documents } = this.state;
		let isValid = true;
		documents.forEach( ( doc: HTDocLookup ) => {
			if ( doc.IsMandatory === 1 && ( doc.docs == undefined || doc.docs.length === 0 ) ) {
				error[ "" + doc.Identity ] = Strings.required;
				isValid = false;
			}
		} );
		this.setState( {
			errorContainer: error,
		} );
		if ( isValid ) {
			return Promise.resolve( documents );
		}
		return Promise.reject( "Damages not valid" );
	}

	private loadDocuments() {
		loadDocsLookUp( HTLookUps.ATTACHMENTS, HTDocType.HANDOVER ).then( docs => {
			const { request } = this.context;
			const documents = docs || [];
			if ( request && request.HandoverRequestAttachments && request.HandoverRequestAttachments.length > 0 ) {
				mapLookupWithAttachments( documents, request.HandoverRequestAttachments );
			}
			this.setState( {
				documents: documents,
				isLoading: false,
			} );
		} );
	}

	private onRejected = () => {
		showErrorMessage( Strings.ht_error_total_file_size );
	};

	private onDrop = ( doc: HTDocLookup, files: File[] ) => {
		onDocDrop( doc, files, ( sDoc: HTDocLookup ) => {
			const { documents, errorContainer } = this.state;
			delete errorContainer[ "" + sDoc.Identity ];
			this.setState( {
				documents: documents.map( ( doc: HTDocLookup ) => {
					return ( sDoc.Identity === doc.Identity ) ? { ...doc, docs: sDoc.docs } : doc;
				} ),
				errorContainer: errorContainer,
			} );
		} );
	};

	private onDelete = ( attachment: HTAttachment, index: number ) => {
		if ( attachment.Identity && attachment.Identity !== 0 ) {
			showLoading();
			EjariApi.deleteTenancyContractDocument( attachment.Identity ).then( () => {
				this.updateDeleteDocs( attachment, index );
				hideLoading();
			} ).catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		} else {
			this.updateDeleteDocs( attachment, index );
		}
	};

	private updateDeleteDocs( attachment: HTAttachment, index: number ) {
		const { documents } = this.state;
		this.setState( {
			documents: documents.map( ( doc: HTDocLookup ) => {
				if ( doc.Identity === attachment.DocumentId ) {
					doc.docs!.splice( index, 1 );
					return doc;
				}
				return doc;
			} ),
		}, () => {
			const { request } = this.context;
			if ( request ) {
				const attachments: HTAttachment[] = [];
				documents.forEach( doc => attachments.push( ...doc.docs || [] ) );
				request.HandoverRequestAttachments = attachments;
				setRequest( request );
			}
		} );
	}
}

function RenderInfo( props: { state: State } ) {
	const { documents } = props.state;
	return <>
		<div className="section-title">
			<h5>{ Strings.documents }</h5>
		</div>
		<div className="flex-grid flex-full">
			<RenderDocs documents={ documents }/>
		</div>
	</>;
}

export default HandoverDocs;
